module.exports = __webpack_public_path__ + "assets/img/news (45).c0540c59.png";